import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';
import { IManualEventOverrides } from '@faire/web/common/pete/types';

export const eventKey = 'product_tile-tile-view';

/**
 * An event for when a product tile impression occurs.
Parameters: context (deprecated, see below), requestId, productToken, promotedBy, dwellTime, maxVisibilityPercent

ImpressionId: BE-generated product impression id
screenContext: ProductTileScreen
containerContext: ProductTileScreenContainer
token: screen specific token e.g. query
https://www.notion.so/faire/Product-Tile-Click-and-Impression-Revamp-Phase-2-38e760e8959749a0a4db905a24e8b134#6cc9995831674b3683cf697cbe66661a
 */
export function trackProductTileTileView(
  context_string: string,
  requestId_string2: string,
  productToken: string,
  promotedBy_string3: string,
  dwellTime_string4: string,
  maxVisibilityPercent_string5: string,
  impressionId_string6: string,
  screenContext_string7: string = '',
  containerContext_string8: string = '',
  token_string9: string = '',
  manualOverrides?: IManualEventOverrides
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    bypassSessionRecording: true,
    realTimeTracking: false,
    manualOverrides,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: {
      context_string,
      requestId_string2,
      productToken,
      promotedBy_string3,
      dwellTime_string4,
      maxVisibilityPercent_string5,
      impressionId_string6,
      screenContext_string7,
      containerContext_string8,
      token_string9,
    },
  });
}
